export default {
  title: 'Administrative Division',

  // Tabs
  tabs: {
    first: 'First Level Division',
    second: 'Second Level Division',
    third: 'Third Level Division',
    fourth: 'Fourth Level Division',
    fifth: 'Fifth Level Division'
  },

  // Search filter area
  search: {
    keyword: 'Keyword Search',
    keywordPlaceholder: 'Division code, division name',
    status: 'Status',
    statusPlaceholder: 'Select status',
    enabled: 'Enabled',
    disabled: 'Disabled',
    country: 'Country',
    countryPlaceholder: 'Select country',
    searchButton: 'Search',
    resetButton: 'Reset'
  },

  // Action buttons
  actions: {
    add: 'Add {level}',
    batchEnable: 'Batch Enable',
    batchDisable: 'Batch Disable',
    enable: 'Enable',
    disable: 'Disable',
    recordsCount: 'Total {count} records'
  },

  // Table columns
  table: {
    name: 'Name',
    nameEn: 'English Name',
    code: 'Code',
    country: 'Country',
    category: 'Category',
    status: 'Status',
    operation: 'Operation',
    noData: '-'
  },

  // Level names
  levels: {
    first: 'First Level Division',
    second: 'Second Level Division',
    third: 'Third Level Division',
    fourth: 'Fourth Level Division',
    fifth: 'Fifth Level Division'
  },

  // Parent names
  parentNames: {
    first: 'Country',
    second: 'First Level Division',
    third: 'Second Level Division',
    fourth: 'Third Level Division',
    fifth: 'Fourth Level Division'
  },

  // Selection modal
  modal: {
    title: 'Select {level}',
    confirmText: 'Confirm Add ({count})',
    selected: 'Selected {count} {level}',
    selectedStatus: 'Selected {count} Divisions, {total} available',
    selectCountry: 'Select Country',
    selectFirstLevel: 'Select First Level Division',
    selectSecondLevel: 'Select Second Level Division',
    selectThirdLevel: 'Select Third Level Division',
    selectFourthLevel: 'Select Fourth Level Division',
    selectParent: 'Please select',
    belongToFirstLevel: 'Belongs to First Level Division',
    belongToSecondLevel: 'Belongs to Second Level Division',
    belongToThirdLevel: 'Belongs to Third Level Division',
    belongToFourthLevel: 'Belongs to Fourth Level Division'
  },

  // Confirmation dialogs
  confirm: {
    enable: 'Are you sure to enable this administrative division?',
    disable: 'Are you sure to disable this administrative division?',
    batchEnable: 'Are you sure to enable the selected {count} administrative divisions?',
    batchDisable: 'Are you sure to disable the selected {count} administrative divisions?'
  },

  // Form validation
  validation: {
    selectItems: 'Please select {level} to add'
  },

  // Message prompts
  messages: {
    selectToEnable: 'Please select administrative divisions to enable',
    selectToDisable: 'Please select administrative divisions to disable',
    selectToAdd: 'Please select {level} to add',
    loadError: 'Failed to load data, please try again later',
    countryLoadError: 'Failed to load country data',
    parentLoadError: 'Failed to load parent division data',
    statusUpdateSuccess: 'Administrative division status updated successfully',
    statusUpdateError: 'Failed to update status, please try again later',
    batchEnableSuccess: 'Enabled {count} administrative divisions',
    batchEnableError: 'Failed to batch enable, please try again later',
    batchDisableSuccess: 'Disabled {count} administrative divisions',
    batchDisableError: 'Failed to batch disable, please try again later',
    associateSuccess: 'Successfully associated {count} {level}',
    associateError: 'Failed to associate, please try again later'
  },

  // Status text
  statusText: {
    enabled: 'Enabled',
    disabled: 'Disabled'
  }
}
